import * as React from 'react';
import { Theme } from '@mui/material/styles';

import { withStyles } from 'tss-react/mui';

interface IProps {
  rotation: number;
  children?: React.ReactNode;
  classes?: any;
}

const styles = (theme: Theme) => ({
  imgRotate: {
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
});

class ZoomableImageRotationWrapper extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  render() {
    const { rotation } = this.props;

    return (
      <span
        className={this.props.classes.imgRotate}
        style={{ transform: `rotate(${rotation}deg)` }}
      >
        {this.props.children}
      </span>
    );
  }
}

export default withStyles(ZoomableImageRotationWrapper, styles);
